import { Component } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { EERIE, OLAF, GREAT_WHITE } from 'HubStyleTokens/colors';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { TOOLBAR_HEIGHT } from '../../../constants/Dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const eerieStyle = {
  color: EERIE
};
const containerStyle = {
  marginTop: '100px'
};
const EmptyThreadToolbar = styled.div.withConfig({
  displayName: "NoFocusedThread__EmptyThreadToolbar",
  componentId: "sc-1lczjj2-0"
})(["height:", "px;background-color:", ";border-bottom:solid 1px ", ";"], TOOLBAR_HEIGHT, OLAF, GREAT_WHITE);
class NoFocusedThread extends Component {
  render() {
    const {
      'data-test-id': dataTestId
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": dataTestId,
      className: "selenium-test-marker-no-focused-thread width-100",
      children: [/*#__PURE__*/_jsx(EmptyThreadToolbar, {}), /*#__PURE__*/_jsx(NavMarker, {
        name: "CHAT_FEED_ZERO_STATE_SUCCESS"
      }), /*#__PURE__*/_jsxs(UIFlex, {
        style: containerStyle,
        justify: 'start',
        align: 'center',
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "conversations-inbox",
            width: "200px"
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          className: "m-top-6 selenium-test-marker-chat-feed-zero-state",
          children: /*#__PURE__*/_jsx("h2", {
            style: eerieStyle,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.zero-state.noFocusedThread"
            })
          })
        })]
      })]
    });
  }
}
NoFocusedThread.displayName = 'NoFocusedThread';
export default NoFocusedThread;